import removeStopWords from "./stopWords.js";
import { XPathSynonyms } from "../../search/search.util.js";
import getSnapshots from "./defiantSnapshots.js";
import { GetTggGuideline, GetTitleGuideline, getTitlePath, getTopicTitle } from "./xmlUtils.js";
import defiantModule from "defiant.js/dist/defiant.js";

const defiant = window.defiant || defiantModule;

const XPathXpress = (flattenedKeywords, synIndex, topicSearchResults = true) => {
  const treatedWords = flattenedKeywords.map((word) => {
    return `contains(|key|, "${word}")`;
  });
  const batchWords = `${treatedWords.join(" and ")}`;
  // console.log(batchWords,flattenedKeywords);

  const searchKeys = ["s"];

  const batchXpression = searchKeys.map((searchKey, index) => {
    return `${batchWords.replace(/\|key\|/g, searchKey)}`;
  });

  if (!topicSearchResults) {
    const expressions = flattenedKeywords.map((word) => `contains(d, "${word}")`);
    const drugXpress = `//*[${expressions.join(" and ")}]`
      .replace(/\/\/\*\[/g, "(")
      .replace(/\)\]/g, "))");
    batchXpression.push(drugXpress);
    // console.log(topicSearchResults,batchXpression,drugXpress);
  }

  const combinedBatchExpression = `${batchXpression.join(" or ")}`;
  // console.log(topicSearchResults,combinedBatchExpression);

  return `//*[${combinedBatchExpression}]`;
};

const SearchXPathSimplified = async (
  searchIndex,
  synIndex,
  topicSearchResults = true,
  sortResults = 0,
) => {
  console.time(">>>SearchXPath" + (topicSearchResults ? "-topic" : "-all"));
  // console.log(searchIndex);
  const searchKeyword =
    searchIndex.charAt(searchIndex.length - 1) === "*" ? searchIndex.slice(0, -1) : searchIndex;
  const keywords = removeStopWords(searchKeyword)
    .toLowerCase()
    .split(" ")
    .map((word) => [word]);
  // TODO: add singularize and pluralize...
  const rScores = { d: 15, s: 10, t: 5, k: 3, g: 1 };
  let flattenedKeywords = [].concat(...keywords);
  let xPathXpress = "//*[]";
  if (searchIndex.length >= 3)
    xPathXpress = XPathXpress(flattenedKeywords, synIndex, topicSearchResults);
  // console.log(xPathXpress);
  const kXPress = XPathSynonyms(synIndex);
  if (kXPress.length > 0) {
    if (searchIndex.length >= 4) {
      xPathXpress = xPathXpress.replace("]", kXPress + "]");
    } else {
      xPathXpress = `//*[${kXPress.replace(" or c", "c")}]`;
    }
    // xPathXpress = `//*[${kXPress.replace(" or c","c")}]`;
  }
  // console.log(((topicSearchResults)?"Topics:":"All:")+xPathXpress);
  const { topicSnapshot: tSnapshot, guidelinesSnapshot: gSnapshot } = await getSnapshots();

  let searchSnapshot = topicSearchResults ? tSnapshot : gSnapshot;
  console.time((topicSearchResults ? "Topic" : "All") + ":defiantSearch Enhanced");

  console.log("searchSnapshot", searchSnapshot, ", xPathXpress: ", xPathXpress);

  const tResults = defiant.search(searchSnapshot, xPathXpress);
  console.timeEnd((topicSearchResults ? "Topic" : "All") + ":defiantSearch");

  flattenedKeywords.push(...synIndex);
  const matchResults = JSON.parse(JSON.stringify(tResults)) // copy object
    .filter((result) => {
      if (result.g === undefined) {
        if (result.t !== undefined) {
          result.g = GetTggGuideline(result).g.replace(/_/g, " ");
        } else {
          result.g = GetTitleGuideline(result).g.replace(/_/g, " ");
        }
      }

      let tValue = "";
      if (result.t !== undefined) {
        tValue = getTopicTitle(result.t).toLowerCase();
        result.t = getTopicTitle(result.t) + "|" + result.t + "|" + getTitlePath(result.t);
        // console.log(result.t);
      }

      let dValue = "";
      if (result.d !== undefined) {
        result.d = dValue = JSON.stringify(result.d).toLowerCase();
      }

      const sValue = (result.s || "").toLowerCase();
      const gValue = (result.g || "").toLowerCase();
      const kValue = (result.k || "").toLowerCase().replace(/,/g, " ");
      const stemValue = searchIndex.charAt(searchIndex.length - 1) === "*";
      // console.log("stemValue",stemValue);
      return flattenedKeywords.some((word) => {
        // console.log(word);
        word = word.toString().toLowerCase();
        const regex = new RegExp(`\\b${word}\\b`, "i");
        if (
          regex.test(sValue) ||
          regex.test(dValue) ||
          regex.test(kValue) ||
          regex.test(tValue) ||
          regex.test(gValue) ||
          stemValue
        ) {
          if (!result.r && !topicSearchResults) {
            result.r = { to: 0, d: 0, s: 0, t: 0, k: 0, g: 0 };
          }
          // console.log(JSON.stringify(result));
          Object.keys(result).forEach((key) => {
            // console.log(key,result[key]);
            if (
              result[key] !== "" &&
              result[key] !== undefined &&
              result[key] !== null &&
              !topicSearchResults &&
              !["i", "r", "k"].includes(key)
            ) {
              // console.log(result,key,result[key],word,result[key].indexOf(word));

              const keywordIndex = result[key].toLowerCase().indexOf(word);
              const percentage =
                keywordIndex === 0
                  ? 100
                  : keywordIndex > 0
                    ? Math.round((1 - keywordIndex / result[key].length) * 100)
                    : 0;
              result.r[key] = (rScores[key] * percentage) / 100;
              result.r.to += result.r[key];
              // console.log("key,[result[key],result.r,result.r[key]]",key,result[key],result.r,result.r[key]);

              if (key === "d") {
                result[key] = JSON.parse(result[key]); // d is already stringified and needs to be parsed.
                // console.log(result[key]);
              }
            }

            if (key === "k" && !topicSearchResults) {
              const k = result[key].split(",");
              const kCount = k.filter((num) => synIndex.includes(parseInt(num) || 0)).length;
              if (kCount > 0) {
                result.r[key] = rScores[key] * kCount;
                result.r.to += result.r[key];
              }
            }
            // console.log(result.s,result.r);
          });
          return true;
        } else return false;
      });
    });

  // console.log("defiant and matched results",tResults,matchResults);
  console.timeEnd(">>>SearchXPath" + (topicSearchResults ? "-topic" : "-all"));
  return matchResults;
};

export default SearchXPathSimplified;
